import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Log Core Web Vitals to console in development
reportWebVitals(({ name, value, rating }) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Web Vital] ${name}: ${Math.round(value)}ms (${rating})`);
  }
});
